export default __webpack_public_path__ + "static/media/ps.dd52ee57.svg";